export default function initPoliticsIndexBlock() {
    [].slice.apply(document.querySelectorAll('.politicsIdx')).forEach(initInstance);
}

const SELECTED = 'is--selected';
const HIDDEN = 'is--hidden';

/**
 *
 * @param {HTMLElement} root
 */
function initInstance(root) {

    const everyBtnEls = [].slice.apply(root.querySelectorAll('.politicsIdx-picker-button'));

    const letterBtnEls = everyBtnEls.filter(btn => btn.dataset.letter !== 'all');
    const allBtnEl = everyBtnEls.find(btn => btn.dataset.letter === 'all');
    const groupEls = [].slice.apply(root.querySelectorAll('.politicsIdx-list-group'));

    const mapping = groupEls.map(groupEl => {
        const btnEl = letterBtnEls.find(el => el.dataset.letter === groupEl.dataset.letter);
        const groupContentEl = groupEl.querySelector('.politicsIdx-groupContent');

        btnEl.addEventListener('click', toggle);

        function toggle(args = {}) {
            isActive() ? hide() : show(args);
        }

        function show(args = {}) {
            groupEl.classList.add(SELECTED);
            groupEl.classList.remove(HIDDEN);

            if (args.onlyGroup) {
                btnEl.classList.remove(SELECTED);
            } else {
                btnEl.classList.add(SELECTED);
                if (allBtnEl.classList.contains(SELECTED)) {
                    allBtnEl.classList.remove(SELECTED);
                    mapping.filter(o => o.groupEl !== groupEl).forEach(o => o.hide());
                }
            }

        }

        function hide() {
            groupEl.classList.remove(SELECTED);
            groupEl.classList.add(HIDDEN);
            btnEl.classList.remove(SELECTED);

            if (!allBtnEl.classList.contains(SELECTED) && mapping.every(o => !o.isActive({ onlyGroup: true }))) {
                showAll();
            }
        }

        function isActive(args = {}) {
            return groupEl.classList.contains(SELECTED) && (args.onlyGroup || btnEl.classList.contains(SELECTED));
        }

        return {
            btnEl,
            groupEl,
            groupContentEl,
            toggle,
            show,
            hide,
            isActive,
        };
    });

    updateGroupsHeight();

    window.addEventListener('resize', updateGroupsHeight);
    window.addEventListener('orientationchange', updateGroupsHeight);

    allBtnEl.addEventListener('click', showAll);

    showAll();

    function showAll() {
        allBtnEl.classList.add(SELECTED);
        mapping.forEach(o => o.show({ onlyGroup: true }));
    }

    function updateGroupsHeight() {
        mapping.forEach(o => {
            o.groupEl.style.height = o.groupContentEl.scrollHeight + 'px';
        });
    }
}
